import { getEnv } from '../config';
import { AsyncReduxState, FormOption } from '../types';

export const tmaUrl = `${getEnv('REACT_APP_TMA_URL')}`;
export const educationSearchUrl = 'https://opleiding.nl/Zoekresultaten.html';

export const authenticationApiUrl = getEnv('REACT_APP_AUTHENTICATION_SERVICE_API_URL');
export const lloApiUrl = getEnv('REACT_APP_LLO_API_URL');

export const sessionDurationInMinutes = 60 * 6;
export const sessionLogoutDelay = 1000 * 60 * sessionDurationInMinutes;
export const debounceDelay = 250;
export const longDebounceDelay = debounceDelay * 2;

export const maxEmploymentYears = 100;

export const lloOrganisationName = 'Leven Lang Ontwikkelen organisatie';

export const defaultFormOption = (): FormOption => ({
    value: '',
    label: '',
});

export const aliasSplitCharacter = '|';

export const initialAsyncReduxState: AsyncReduxState = {
    isLoading: false,
    isSuccessful: false,
    error: '',
};
